import Fullscreen from 'components/Icons/Fullscreen';
import styles from './FullscreenControl.module.scss';

const FullscreenControl = ({
  isFullscreen,
  toggleFullscreen,
  supportsFullscreen,
}: {
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  supportsFullscreen: boolean;
}) => {
  if (!supportsFullscreen) {
    return null;
  }

  return (
    <button
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      type="button"
      onClick={toggleFullscreen}
      className={styles.fullscreenControl}
    >
      <Fullscreen isFullscreen={isFullscreen} />
    </button>
  );
};

export default FullscreenControl;
